import * as Vuex from "vuex";
import { Call, DownloadStatusAudio, DownloadStatusPcap } from "@/entities/call";
import { actions } from "./actions";

const callsModule: Vuex.Module<CallStoreState, {}> = {
  state: {
    loading: false,
    calls: [],
  },
  getters: {
    callsLoading(state) {
      return state.loading;
    },
    callsTable(state) {
      return state.calls;
    },
  },
  mutations: {
    SET_CALLS_PAGINATION(state, payload: Call[]) {
      state.calls.push(...payload);
    },
    SET_CALLS(state, payload: Call[]) {
      payload.forEach((call) => {
        call.isDownloadingAudio = false;
        call.isDownloadingPcap = false;
      });
      state.calls = payload;
    },
    CALLS_TOGGLE_LOADING(state) {
      state.loading = !state.loading;
    },
    SET_DOWNLOAD_STATUS_AUDIO(state, status: DownloadStatusAudio) {
      const idx = state.calls.findIndex((e) => e.id == status.id);
      state.calls[idx].isDownloadingAudio = status.status;
    },
    SET_DOWNLOAD_STATUS_PCAP(state, status: DownloadStatusPcap) {
      const idx = state.calls.findIndex((e) => e.id == status.id);
      state.calls[idx].isDownloadingPcap = status.status;
    },
    SET_CALL(state, call: Call) {
      const calls = [...state.calls];
      const idx = calls.findIndex((item) => item.id == call.id);
      if (idx != -1) {
        state.calls.splice(idx, 1, call);
      }
    },
  },
  actions: actions,
};

export default callsModule;

export type CallStoreState = {
  loading: boolean;
  calls: Call[];
};
